var $a6bf4586076d348a$exports = {};
$a6bf4586076d348a$exports = {
    "colorSwatchPicker": `Renk \xf6rnekleri`,
    "dropzoneLabel": `B\u{131}rakma B\xf6lgesi`,
    "selectPlaceholder": `Bir \xf6\u{11F}e se\xe7in`,
    "tableResizer": `Yeniden boyutland\u{131}r\u{131}c\u{131}`
};


export {$a6bf4586076d348a$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
